export const MenuTestIdFactory = {
    // Bases - can be used externally for regex matching in getByTestId
    // to select multiple components regardless of their passed test id
    getMenuBase: () => 'menu',
    getMenuItemBase: () => [MenuTestIdFactory.getMenuBase(), 'item'].join('-'),
    getMenuGroupTitleBase: () => [MenuTestIdFactory.getMenuBase(), 'group', 'title'].join('-'),
    getMenuListBase: () => [MenuTestIdFactory.getMenuBase(), 'ul'].join('-'),
    // for test id generation
    getMenuDialogTestId: (testId) => [MenuTestIdFactory.getMenuBase(), testId].join('-'),
    getMenuItemTestId: (testId) => [MenuTestIdFactory.getMenuItemBase(), testId].join('-'),
    getMenuItemTextTestId: (testId) => [MenuTestIdFactory.getMenuItemTestId(testId), 'text'].join('-'),
    getMenuGroupTitleTestId: (testId) => [MenuTestIdFactory.getMenuGroupTitleBase(), testId].join('-'),
    getMenuGroupTitleTextTestId: (testId) => [MenuTestIdFactory.getMenuGroupTitleTestId(testId), 'text'].join('-'),
    getMenuListTestId: (testId) => [MenuTestIdFactory.getMenuListBase(), testId].join('-'),
};
